module.exports = __webpack_public_path__ + "static/media/to-bottom.18e6842c.svg";